import { useTheme } from '@/src/context/ThemeContext';
import { WelcomeScreen } from '@/src/presentation/screens/WelcomeScreen';
import { useRouter } from 'expo-router';

export default function WelcomeContainer() {
  const router = useRouter();
  const { colors, isDark } = useTheme();

  return (
    <WelcomeScreen
      isDark={isDark}
      colors={colors}
      onGetStarted={() => router.push('/auth/register')}
      onSignIn={() => router.push('/auth/login')}
    />
  );
}
